{
  "on": "sur",
  "none": "Aucun",
  "device": "équipement | équipement | équipements",
  "operation": "opération | opération | opérations",
  "profile": "profil | profil | profils",
  "application": "applicatif | applicatif | applicatifs",
  "campaign": "campagne | campagne | campagnes",
  "user": "utilisateur | utilisateur | utilisateurs",
  "group": "groupe | groupe | groupes",
  "userGroup": "groupe d'utilisateurs | groupe d'utilisateurs | groupes d'utilisateurs",
  "firmware": "firmware | firmware | firmwares",
  "applicationMgt": "application | application |applications",
  "dtwins": "équipement | équipement | équipements"
}
